import { Box } from '@mui/material';
import SelectBase from 'components/forms/fields/select-field/select-base/select-base.component';
import { useLocationHoursContext } from 'components/location-hours/location-hours.context';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CustomHeaderToolbar = () => {
  const { t } = useTranslation();

  const {
    normalHours: { handleCalendarViewChange },
  } = useLocationHoursContext();

  const [calendarView, setCalendarView] = useState('week');

  const calendarViewTypes = [
    {
      label: t(
        'LocationHours.normalHours.calendar.customHeaderToolbar.calenderViews.list',
      ),
      id: 'list',
      test: 'NormalHoursCalendar.Toolbar.CalenderViews.List.Button',
    },
    {
      label: t(
        'LocationHours.normalHours.calendar.customHeaderToolbar.calenderViews.week',
      ),
      id: 'week',
      test: 'NormalHoursCalendar.Toolbar.CalenderViews.Week.Button',
    },
  ];

  const handleCalendarView = e => {
    setCalendarView(e.target.value);
    handleCalendarViewChange(e.target.value);
  };

  return (
    <Box data-testid="NormalHoursCalendar.Toolbar">
      <SelectBase
        options={calendarViewTypes}
        onChange={handleCalendarView}
        value={calendarView}
        size="small"
        color="primary"
        fullWidth={false}
        data-testid="NormalHoursCalendar.Toolbar.View.Select"
      />
    </Box>
  );
};

export default CustomHeaderToolbar;
